import { useQuery } from 'react-query';
import { QUERY_KEYS } from '@constants';
import { fetchSlideSequence } from '@services/scenarios';
import { getErrorMessage } from '@utils/errorHandling';

/* Custom hook wrappers around react query mutations */

const { slideSequenceQuery } = QUERY_KEYS;

export const useSlideSequenceQuery = (scenarioId) => useQuery([slideSequenceQuery, scenarioId], 
    () => fetchSlideSequence(scenarioId),
    {
        onError: error => getErrorMessage(error),
        keepPreviousData: true
    }
);
